import axios from "@/plugins/axios.js";

export default {
  async getAllProducts() {
    const products = await axios.getData(
      "/auth/get-all-products",
      localStorage.getItem("token")
    );
    return products;
  },

  async getInventoryForAllProducts() {
    const inventory = await axios.getData(
      "/auth/get-inventory-for-all-products",
      localStorage.getItem("token")
    );
    return inventory;
  },

  async getAllProductsInStock() {
    const products = await axios.getData(
      "/auth/get-all-products-in-stock",
      localStorage.getItem("token")
    );
    return products;
  },

  async createProduct(name, cost, price, categoryID, code, list) {
    const product = await axios.postDataWithToken(
      "/auth/save-product",
      {
        name: name,
        code: code,
        cost: cost,
        price: price,
        categoryID: categoryID,
        list: list,
      },
      localStorage.getItem("token")
    );
    return product;
  },

  async createProductAndAddToReceivings(
    name,
    cost,
    price,
    categoryID,
    code,
    list,
    supplierID,
    date,
    quantity
  ) {
    const product = await axios.postDataWithToken(
      "/auth/save-product-and-add-to-receivings",
      {
        name: name,
        code: code,
        cost: cost,
        price: price,
        categoryID: categoryID,
        list: list,
        supplierID: supplierID,
        date: date,
        quantity: quantity,
      },
      localStorage.getItem("token")
    );
    return product;
  },

  async recordReceivingsToReceivingsTable(
    productID,
    supplierID,
    date,
    quantity
  ) {
    const newlyRecordedReceiving = await axios.postDataWithToken(
      "/auth/record-receivings-to-receivings-table",
      {
        productID: productID,
        supplierID: supplierID,
        date: date,
        quantity: quantity,
      },
      localStorage.getItem("token")
    );
    return newlyRecordedReceiving;
  },

  async getAllServices() {
    const response = await axios.getData(
      "/auth/get-all-services",
      localStorage.getItem("token")
    );
    return response;
  },

  async createService(name, cost, price, categoryID, code, list) {
    const service = await axios.postDataWithToken(
      "/auth/save-service",
      {
        name: name,
        code: code,
        cost: cost,
        price: price,
        categoryID: categoryID,
        list: list,
      },
      localStorage.getItem("token")
    );
    return service;
  },

  async getAllSuppliers() {
    const response = await axios.getData(
      "/auth/get-all-suppliers",
      localStorage.getItem("token")
    );
    return response;
  },

  async getAllServiceProviders() {
    const response = await axios.getData(
      "/auth/get-all-service-providers",
      localStorage.getItem("token")
    );
    return response;
  },

  async saveSupplier(name, contactPerson, email, address, phone, city, code) {
    const supplier = await axios.postDataWithToken(
      "/auth/save-supplier",
      {
        name: name,
        code: code,
        contactPerson: contactPerson,
        phone: phone,
        email: email,
        city: city,
        address: address,
      },
      localStorage.getItem("token")
    );
    return supplier;
  },

  async saveServiceProvider(
    name,
    contactPerson,
    email,
    address,
    phone,
    city,
    code
  ) {
    const response = await axios.postDataWithToken(
      "/auth/save-service-provider",
      {
        name: name,
        code: code,
        contactPerson: contactPerson,
        phone: phone,
        email: email,
        city: city,
        address: address,
      },
      localStorage.getItem("token")
    );
    return response;
  },
};
